<template>
  <EditorAttributionContainer :is-position-reversed="isPositionReversed">
    <p
      class="text-xs w-full text-white font-semi-bold text-decoration-none flex gap-1 items-center justify-center mb-0"
      style="z-index: 100"
    >
      {{ I18n.t("editor.magic_background.variants.variant_a.creating_ai_scene") }}
    </p>
  </EditorAttributionContainer>
</template>
<script setup lang="ts">
import EditorAttributionContainer from "@/components/prism/editor_attribution_container.vue";
import "@/src/i18n";
const props = defineProps<{
  isPositionReversed?: boolean;
}>();
</script>
